WiseMetering.Collection.Tars = WiseMetering.Collection.extend({
    hasOrganization: false,
    model: WiseMetering.Model.Tar,
    url: '/tars'
});
